import React, { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  CreateUpdateExamWithTestsDto,
  GetExamArticleDtoTypeEnum,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { useNavigation } from '../../../common/navigation';
import { examData } from '../../../common/spdCore/contexts/ExamContext';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { AddHarmfulFactory } from '../../components/TestGiving/AddHarmfulFactory';
import { TakenCareOf } from '../../../common/spdCore/validation/schemas';

type ParamTypes = {
  id: string;
};

export const ExamHarmfulFactorsEditorView: React.FC = () => {
  const spd = useSpdCore();
  const nav = useNavigation();

  const [exam, setExam] = useState<CreateUpdateExamWithTestsDto>();
  const [articleDoctorsIds, setArticleDoctorsIds] = useState<string[]>([]);
  const [articlePsychologistsIds, setArticlePsychologistsIds] = useState<
    string[]
  >([]);

  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);

  const { id } = useParams<ParamTypes>() as {
    id: string;
  };

  useEffect(() => {
    spd.exams
      .getExam(id)
      .then(exam => {
        setExam(examData(exam));
        setArticleDoctorsIds(
          (exam.examArticles || [])
            .filter(ea => ea.type === GetExamArticleDtoTypeEnum.Doctor)
            .map(ea => ea.articleId),
        );
        setArticlePsychologistsIds(
          (exam.examArticles || [])
            .filter(ea => ea.type === GetExamArticleDtoTypeEnum.Psychologist)
            .map(ea => ea.articleId),
        );
      })
      .catch(error => {
        console.error('Wystąpił problem z pobraniem badania', error);
      });
  }, [spd.exams, id]);

  const onSave = async () => {
    try {
      if (exam) {
        const ex = await spd.exams.updateWithTests(id, {
          ...exam,
          articleDoctorsIds,
          articlePsychologistsIds,
        });

        setExam(examData(ex));
        setShowSaveErrors(false);
        void nav.goBack();
      }
    } catch (response) {
      setSaveErrors([
        'Wystąpił problem z zapisaniem czynników szkodliwych w badaniu. ' +
          (await responseErrors(response as ResponseError)),
      ]);
      setShowSaveErrors(true);
      return false;
    }
  };

  const propertyChange = (obj: Partial<CreateUpdateExamWithTestsDto>) => {
    setExam({ ...exam, ...obj });
  };

  return (
    <Card>
      <Card.Header>{`Edycja badania ${exam?.number}`}</Card.Header>
      <Card.Body>
        <AddHarmfulFactory
          referralFromEmployer={exam?.referralFromEmployer || undefined}
          areHarmfulFactors={exam?.areHarmfulFactors || undefined}
          areResultsHarmfulFactors={exam?.areResultsHarmfulFactors || undefined}
          takenCareOf={
            (exam?.takenCareOf as unknown as TakenCareOf) || undefined
          }
          harmfulFactorsIds={exam?.harmfulFactorsIds}
          articleDoctorsIds={articleDoctorsIds}
          articlePsychologistsIds={articlePsychologistsIds}
          propertyChange={propertyChange}
        />
        <ValidationAlert
          show={showSaveErrors}
          errors={saveErrors}
          className="mt-3"
        />
        <Button
          type="submit"
          className="w-100 btn btn-lg btn-login mt-3"
          onClick={onSave}
        >
          Zapisz
        </Button>
      </Card.Body>
    </Card>
  );
};
